var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#83ACEB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.086 4.95a2 2 0 0 0-1.414-.586H4.5v7.171a2 2 0 0 0 .586 1.414l7 7a2 2 0 0 0 2.828 0l5.172-5.171a2 2 0 0 0 0-2.829z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#83ACEB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.5 9.364a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
export default SvgTag;